import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicHome from "./pages/PublicHome";
import BookingChooser from "./pages/BookingChooser";
import BookingFlow from "./pages/BookingFlow";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import Schedule from "./pages/Schedule";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Packages from "./pages/Packages";
import Services from "./pages/Services";
import Practitioners from "./pages/Practitioners";
import Waivers from "./pages/Waivers";
import Refills from "./pages/Refills";
import Reports from "./pages/Reports";
import PractitionerDay from "./pages/PractitionerDay";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<PublicHome />} />
            <Route path="/book" element={<BookingChooser />} />
            <Route path="/book/:serviceId" element={<BookingFlow />} />

            {/* Auth */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin (admin role) */}
            <Route path="/admin" element={<ProtectedRoute roles={["admin","practitioner"]}><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/schedule" element={<ProtectedRoute roles={["admin","practitioner"]}><Schedule /></ProtectedRoute>} />
            <Route path="/admin/clients" element={<ProtectedRoute roles={["admin","practitioner"]}><Clients /></ProtectedRoute>} />
            <Route path="/admin/clients/:id" element={<ProtectedRoute roles={["admin","practitioner"]}><ClientDetail /></ProtectedRoute>} />
            <Route path="/admin/packages" element={<ProtectedRoute roles={["admin","practitioner"]}><Packages /></ProtectedRoute>} />
            <Route path="/admin/services" element={<ProtectedRoute roles={["admin"]}><Services /></ProtectedRoute>} />
            <Route path="/admin/practitioners" element={<ProtectedRoute roles={["admin"]}><Practitioners /></ProtectedRoute>} />
            <Route path="/admin/waivers" element={<ProtectedRoute roles={["admin"]}><Waivers /></ProtectedRoute>} />
            <Route path="/admin/refills" element={<ProtectedRoute roles={["admin","practitioner"]}><Refills /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute roles={["admin","practitioner"]}><Reports /></ProtectedRoute>} />

            {/* Practitioner */}
            <Route path="/practitioner" element={<ProtectedRoute roles={["admin","practitioner"]}><PractitionerDay /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
